import React from 'react';
import { BsPersonFill } from 'react-icons/bs';
import { GiDiceSixFacesFive } from 'react-icons/gi';
import noImage from '../../../../../assets/images/no_image.svg';
import css from './MemoryCard.module.scss';
import { StepWithAction } from './MemoryCardTypes';
import { convertValue } from './utils';
import { BranchStepMemoryRollType } from '../../../../../dorian-shared/types/branch/BranchStep';
import { isCharacterReferenceMemoryType } from '../../../Book/MemoryBank/memoryBankTypes';

interface MemoryCardProps {
  stepWithAction: StepWithAction;
}

function renderDiceValue(rollType: BranchStepMemoryRollType) {
  switch (rollType) {
    case BranchStepMemoryRollType.Set:
      return <GiDiceSixFacesFive size={16} />;
    case BranchStepMemoryRollType.Increase:
      return (
        <>
          +<GiDiceSixFacesFive size={16} />
        </>
      );
    case BranchStepMemoryRollType.Decrease:
      return (
        <>
          -<GiDiceSixFacesFive size={16} />
        </>
      );
    case BranchStepMemoryRollType.Dice:
      return <GiDiceSixFacesFive size={16} />;
    default:
      return <GiDiceSixFacesFive size={16} />;
  }
}

export function MemoryCard(props: MemoryCardProps) {
  const { stepWithAction } = props;
  const {
    memoryIconUrl, value, memoryName, type, isToggleShowIn, rollType, memoryType,
  } = stepWithAction;
  const title = `${memoryName}: ${value}`;
  const iconUrl = memoryIconUrl || memoryIconUrl !== ''
    ? memoryIconUrl
    : noImage;

  const isRandomStep = rollType !== undefined;
  const displayValue = isRandomStep ? renderDiceValue(rollType) : convertValue(value);

  /* Character memory cards use blue styling with a person silhouette */
  if (isCharacterReferenceMemoryType(memoryType) && type === 'card') {
    return (
      <div
        className={`${css.memoryCardContainer} ${css.characterMemoryCard}`}
        title={`Character: ${memoryName}`}
      >
        <div className={css.characterMemoryIcon}>
          <BsPersonFill size={18} />
        </div>
        <div className={css.characterMemoryLabel}>
          {memoryName}
        </div>
      </div>
    );
  }

  return (
    <div
      className={css.memoryCardContainer}
      title={title}
    >
      {isToggleShowIn && (
        <>
          <div className={css.memoryCardToggle} />
          <div className={css.memoryCardToggleEye}>
            
          </div>
        </>
      )}
      {type === 'card'
        ? (
          <>
            <img src={iconUrl} alt="icon" />
            <div className={css.memoryCardRegular}>
              {displayValue}
            </div>
          </>
        )
        : (
          <div className={css.memoryCardMore}>
            {isRandomStep ? displayValue : `+${displayValue}`}
          </div>
        )}
    </div>
  );
}
